























import Vue, { PropType } from 'vue';
// import ModelOperation from '@/utils/modelOperation';
// const { spdengine } = window as any;
export default Vue.extend({
    props: {
        benchId: { type: Number },
        detailData: { type: Array as PropType<{ key: string; value: string }[]> },
        instanceName: { type: String },
    },

});
